import React, { FC } from 'react';
import logo from './logo.svg';
import './App.css';
import { Container } from 'react-bootstrap';
import Header from './components/Header';
import Body from './components/Body/Body';
import Footer from './components/Footer';
import { AudioPlayerProvider } from 'react-use-audio-player';

const App: FC = () => {
  return (
    <AudioPlayerProvider>
      <div className="App">
        <Container fluid="md">
          <Header />
          <Body />
          <Footer />
        </Container>
      </div>
    </AudioPlayerProvider>
  );
};

export default App;
